
export const DATASOURCE_UPDATE_DATA = 'DATASOURCE_UPDATE_DATA';


export const DATASOURCE_CREATE = 'DATASOURCE_CREATE';
export const DATASOURCE_CREATE_SUCCESS = 'DATASOURCE_CREATE_SUCCESS';
export const DATASOURCE_CREATE_ERROR = 'DATASOURCE_CREATE_ERROR';

export const DATA_SOURCE_DELETE = 'DATA_SOURCE_DELETE';
export const DATA_SOURCE_DELETE_SUCCESS = 'DATA_SOURCE_DELETE_SUCCESS';
export const DATA_SOURCE_DELETE_ERROR = 'DATA_SOURCE_DELETE_ERROR';

export const EDIT_DATASOURCE_CONFIG = 'EDIT_DATASOURCE_CONFIG';
export const EDIT_DATASOURCE_CONFIG_SUCCESS = 'EDIT_DATASOURCE_CONFIG_SUCCESS';
export const EDIT_DATASOURCE_CONFIG_ERROR = 'EDIT_DATASOURCE_CONFIG_ERROR';

export const DATA_SOURCE_LIST = 'DATA_SOURCE_LIST';
export const DATA_SOURCE_LIST_SUCCESS = 'DATA_SOURCE_LIST_SUCCESS';
export const DATA_SOURCE_LIST_ERROR = 'DATA_SOURCE_LIST_ERROR';